const getVariations = (variations) => {
  if (!variations) return {};
  return variations;
};

export default getVariations;
